module.exports = __webpack_public_path__ + "static/media/cycling.42f11224.gif";